<!-- Modern Customers Filters -->
<div class="customers-filters modern-filters" [class.drawer-mode]="drawerMode">
  <!-- Header with Filters title and Clear All button -->
  <div class="filters-header-main" [ngClass]="drawerMode ? 'p-3' : 'mb-3'">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-filter text-gray-600 mr-2"></i>
        <h2 class="filters-title">Filters</h2>
      </div>
      <!-- Clear All button -->
      <div class="header-right">
        <button
          class="clear-all-btn"
          [disabled]="loading || !hasActiveFilters()"
          [class.has-filters]="hasActiveFilters()"
          (click)="onClearFilters()"
          title="Clear all active filters"
        >
          Clear All
        </button>
      </div>
    </div>
  </div>

  <!-- Scrollable Filter Content Container -->
  <div
    class="filters-content-scroll"
    [ngClass]="drawerMode ? 'drawer-scroll' : 'default-scroll'"
  >
    <!-- Search Section (matches old QMC search input) -->
    <div class="search-section" [ngClass]="getSearchSectionClass()">
      <div class="search-input-wrapper">
        <p-iconfield iconPosition="left" styleClass="w-full">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            pInputText
            [formControl]="filterForm.controls.search"
            placeholder="Search by name, email..."
            [disabled]="loading"
            class="modern-search-input w-full"
          />
        </p-iconfield>
      </div>
    </div>

    <!-- Date Filters Section (matches old QMC Start Date / End Date) -->
    <div
      class="filter-section date-section"
      [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Customer Created</h3>
      </div>

      <div class="date-filter-group">
        <p-datepicker
          [formControl]="filterForm.controls.customerCreatedRange"
          selectionMode="range"
          [readonlyInput]="true"
          [showIcon]="true"
          [showClear]="true"
          [maxDate]="maxDate"
          placeholder="Select date range"
          [disabled]="loading"
          dateFormat="mm/dd/yy"
          class="w-full"
          appendTo="body"
          styleClass="w-full"
        />
      </div>
    </div>

    <!-- Include Deleted Section (matches old QMC "Filter by Deleted" checkbox) -->
    <div
      class="filter-section deleted-section"
      [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Status</h3>
      </div>

      <div class="checkbox-group">
        <div class="checkbox-item">
          <p-checkbox
            [formControl]="filterForm.controls.includeDeleted"
            [binary]="true"
            inputId="includeDeleted"
            [disabled]="loading"
          />
          <label for="includeDeleted" class="checkbox-label ml-2">
            Filter by Deleted
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
